var NAMESPACE = 'td';

var Carousel = { render: function render() {
    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('div', { staticClass: "td-carousel", on: { "mouseenter": function mouseenter($event) {
          _vm.autoPlay && _vm.clearAutoPlayListener();
        }, "mouseleave": function mouseleave($event) {
          _vm.autoPlay && _vm.addAutoPlayListener();
        } } }, [_c('div', { staticClass: "td-carousel__container" }, [_c('ul', [_vm._t("default")], 2)]), _vm._v(" "), _vm.showArrowButton ? [_c('span', { staticClass: "td-carousel__button td-carousel__button--left", on: { "click": _vm.decreaseActiveIndex } }, [_c('i', { staticClass: "td-icon-arrow-left" })]), _vm._v(" "), _c('span', { staticClass: "td-carousel__button td-carousel__button--right", on: { "click": _vm.increaseActiveIndex } }, [_c('i', { staticClass: "td-icon-arrow-right" })])] : _vm._e(), _vm._v(" "), _vm.indicatorType === 'preview' ? _c('div', { staticClass: "td-carousel__indicators td-carousel__indicators--image" }, [_c('ul', _vm._l(_vm.indicatorListCombine, function (item, index) {
      return _c('li', { key: item + index, staticClass: "td-carousel__indicator", class: { 'is-active': index === _vm.activeIndex }, on: { "click": function click($event) {
            _vm.trigger === 'click' && (_vm.activeIndex = index);
          }, "mouseenter": function mouseenter($event) {
            _vm.trigger === 'hover' && (_vm.activeIndex = index);
          } } }, [_c('a', { attrs: { "href": "javascript:;" } }, [_c('img', { attrs: { "src": item } })])]);
    }), 0)]) : _vm.indicatorType === 'line' ? _c('div', { staticClass: "td-carousel__indicators" }, [_c('ul', _vm._l(_vm.carouselItemList, function (item, index) {
      return _c('li', { key: index, staticClass: "td-carousel__indicator", class: { 'is-active': index === _vm.activeIndex }, on: { "click": function click($event) {
            _vm.trigger === 'click' && (_vm.activeIndex = index);
          }, "mouseenter": function mouseenter($event) {
            _vm.trigger === 'hover' && (_vm.activeIndex = index);
          } } });
    }), 0)]) : _vm.indicatorType === 'text' ? _c('div', { staticClass: "td-carousel__indicators td-carousel__indicators--text" }, [_c('ul', _vm._l(_vm.indicatorListCombine, function (item, index) {
      return _c('li', { key: item + index, staticClass: "td-carousel__indicator", class: { 'is-active': index === _vm.activeIndex }, on: { "click": function click($event) {
            _vm.trigger === 'click' && (_vm.activeIndex = index);
          }, "mouseenter": function mouseenter($event) {
            _vm.trigger === 'hover' && (_vm.activeIndex = index);
          } } }, [_c('span', [_vm._v(_vm._s(item))])]);
    }), 0)]) : _vm._e()], 2);
  }, staticRenderFns: [],
  name: NAMESPACE + '-carousel',
  props: {
    initIndex: {
      type: Number,
      default: 0
    },
    trigger: {
      type: String,
      default: 'hover',
      validator: function validator(val) {
        return ['click', 'hover'].includes(val);
      }
    },
    showArrowButton: {
      type: Boolean,
      default: false
    },
    indicatorType: {
      type: String,
      default: 'line',
      validator: function validator(val) {
        return ['none', 'preview', 'line', 'text'].includes(val);
      }
    },
    previewImageUrlList: {
      type: Array
    },
    indicatorList: {
      type: Array
    },
    autoPlay: {
      type: Boolean,
      default: false
    },
    timeout: {
      type: Number,
      default: 1000
    }
  },
  computed: {
    indicatorListCombine: function indicatorListCombine() {
      if (this.previewImageUrlList && Array.isArray(this.previewImageUrlList)) {
        return this.previewImageUrlList;
      } else {
        return this.indicatorList;
      }
    }
  },
  data: function data() {
    return {
      activeIndex: 0,
      carouselItemList: [],
      autoPlayTimer: null
    };
  },
  mounted: function mounted() {
    this.getCarouselItemList();
    this.activeIndex = this.initIndex;
    this.setCarouselActiveByIndex(this.activeIndex);
    if (process.env.NODE_ENV === 'development' && this.indicatorType === 'preview' && this.indicatorListCombine.length !== this.carouselItemList.length) {
      console.error('The length of previewImageUrlList should be the same as carouseleItemList');
    }
    if (this.autoPlay) {
      this.addAutoPlayListener();
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.clearAutoPlayListener();
  },

  watch: {
    $children: {
      immediate: true,
      handler: function handler() {
        this.getCarouselItemList();
      }
    },
    activeIndex: {
      immediate: true,
      handler: function handler(val) {
        this.setCarouselActiveByIndex(val);
      }
    }
  },
  methods: {
    autoPlayCallback: function autoPlayCallback() {
      this.increaseActiveIndex();
    },
    addAutoPlayListener: function addAutoPlayListener() {
      if (!this.autoPlayTimer) {
        this.autoPlayTimer = window.setInterval(this.autoPlayCallback, this.timeout);
      }
    },
    clearAutoPlayListener: function clearAutoPlayListener() {
      window.clearInterval(this.autoPlayTimer);
      this.autoPlayTimer = null;
    },
    getCarouselItemList: function getCarouselItemList() {
      this.carouselItemList = this.$children.filter(function (item) {
        return item.$options._componentTag === 'td-carousel-item';
      });
    },
    setCarouselActiveByIndex: function setCarouselActiveByIndex(index) {
      var _this = this;

      if (index < 0 || index >= this.carouselItemList.length) {
        if (process.env.NODE_ENV === 'development') {
          console.warn('ivalid carousel item index');
        }
        return;
      }
      this.carouselItemList.forEach(function (carouselItem, idx) {
        _this.carouselItemList[idx].active = false;
        if (idx === index) {
          _this.carouselItemList[idx].active = true;
        }
      });
      this.$emit('change', index);
    },
    setCarouselItemActive: function setCarouselItemActive(item) {
      var index = this.carouselItemList.findIndex(function (carousel) {
        return carousel === item;
      });
      this.setCarouselActiveByIndex(index);
    },
    decreaseActiveIndex: function decreaseActiveIndex() {
      var length = this.carouselItemList.length;
      this.activeIndex = (this.activeIndex - 1 + length) % length;
    },
    increaseActiveIndex: function increaseActiveIndex() {
      var length = this.carouselItemList.length;
      this.activeIndex = (this.activeIndex + 1) % length;
    }
  }
};

Carousel.install = function (Vue) {
  Vue.component(Carousel.name, Carousel);
};

export default Carousel;
